// @flow
import parseLatLng from 'mz-utils/parseLatLng'
import type { Location } from '../../../models/location'
import type { RideLocation } from '../../../api_types'

// Utils
function buildRideLocation(loc: RideLocation): Location {
  return {
    name: loc.address || '',
    customName: loc.custom_name || '',
    address: loc.address || '', // important for `getMaximizedLocation`
    fullAddress: loc.formatted_address || loc.address || '',
    iataCode: loc.iata_code || '',
    country: '',
    notSpecific: false,
    timezone: '',
    placeId: loc.place_id || '',
    airportName: (loc.iata_code && loc.formatted_address) || '',
    trainStationName: '',
    isCruisePort: false,
    isTrainStation: false,
    type: loc.iata_code ? 'airport' : 'place',
    favoriteId: loc.favorite_id,
    favoriteSource: loc.favorite_source,
    ...parseLatLng(loc.lat, loc.lng),
  }
}

export default buildRideLocation
